import { FILL_SELFIE_VERIFICATION_PENDING } from 'Lib/colorsAndFills';

import {
  SELFIE_CHALLENGE_REQUIRED,
  SELFIE_CHALLENGE_SUBMITTED,
  SELFIE_VERIFICATION_REVIEW,
  SELFIE_VERIFICATION_UNVERIFIED,
  SELFIE_VERIFICATION_VERIFIED,
  type SelfieVerificationStatuses,
} from 'Containers/ModalManager/modals/SelfieVerification/constants';
import { STEP_POSE_VERIFICATION } from 'Containers/ModalManager/modals/SelfieVerification/constants/steps';
import type { SelfieVerificationSteps } from 'Containers/ModalManager/modals/SelfieVerification/types';

import ClockIcon from 'Assets/reactSvgs/ClockIcon';
import VerifiedIcon from 'Assets/reactSvgs/VerifiedIcon';

export const CONTENT_MAX_WIDTH = '275px';

export type SelfieChallengeStatus = 'challenge_required' | 'challenge_submitted';

type SelfieChallengeStatuses = SelfieChallengeStatus[];

export const SELFIE_CHALLENGE_SELFIE_VERIFICATION_STEPS: SelfieVerificationSteps = [
  STEP_POSE_VERIFICATION,
];

export const SELFIE_CHALLENGE_REQUIRED_STATUSES: SelfieChallengeStatuses = [
  SELFIE_CHALLENGE_REQUIRED,
  SELFIE_CHALLENGE_SUBMITTED,
];

export const SELFIE_CHALLENGE_NOT_REQUIRED_STATUSES: SelfieVerificationStatuses = [
  SELFIE_VERIFICATION_REVIEW,
  SELFIE_VERIFICATION_UNVERIFIED,
  SELFIE_VERIFICATION_VERIFIED,
];

export const SELFIE_CHALLENGE_NAMESPACE_INTRO = 'intro';
export const SELFIE_CHALLENGE_NAMESPACE_REVIEW = 'review';

type StatusConfig = {
  avatarClassName: string;
  avatarIcon: React.ReactNode | undefined;
  buttonText?: string;
  headingSubtitleClassName: string;
  logoClassName?: string;
  sectionClassName?: string;
  subtitle: string;
  title: string;
};

type SelfieChallengeConfigByStatus = {
  challenge_required: StatusConfig;
  challenge_submitted: StatusConfig;
  verified: StatusConfig;
};

// classNames shared between challenge submitted and selfies verified pages
const AVATAR_CLASS_NAME = 'Mb(16px) Mb(24px)--ml';
const ICON_CLASS_NAME = 'End(8px) Pos(a) Sq(24px) T(0)';
const LOGO_CLASS_NAME = 'Pos(a)';
const SUBTITLE_CLASS_NAME = 'Mt(16px) Mt(20px)--ml';

export const SELFIE_CHALLENGE_CONFIG_BY_STATUS: SelfieChallengeConfigByStatus = {
  [SELFIE_CHALLENGE_REQUIRED]: {
    avatarClassName: 'Mb(24px)',
    avatarIcon: null,
    buttonText: 'continue',
    headingSubtitleClassName: 'My(20px)',
    logoClassName: 'Pos(r) Pos(a)--ml',
    sectionClassName: 'Jc(sb) Jc(c)--ml',
    subtitle: `SelfieChallenge.${SELFIE_CHALLENGE_NAMESPACE_INTRO}.subtitle`,
    title: `SelfieChallenge.${SELFIE_CHALLENGE_NAMESPACE_INTRO}.title`,
  },
  [SELFIE_CHALLENGE_SUBMITTED]: {
    avatarClassName: AVATAR_CLASS_NAME,
    avatarIcon: <ClockIcon className={ICON_CLASS_NAME} fill={FILL_SELFIE_VERIFICATION_PENDING} />,
    headingSubtitleClassName: SUBTITLE_CLASS_NAME,
    logoClassName: LOGO_CLASS_NAME,
    sectionClassName: undefined,
    subtitle: `SelfieChallenge.${SELFIE_CHALLENGE_NAMESPACE_REVIEW}.subtitle`,
    title: `SelfieChallenge.${SELFIE_CHALLENGE_NAMESPACE_REVIEW}.title`,
  },
  [SELFIE_VERIFICATION_VERIFIED]: {
    avatarClassName: AVATAR_CLASS_NAME,
    avatarIcon: <VerifiedIcon className={ICON_CLASS_NAME} />,
    buttonText: 'done',
    headingSubtitleClassName: SUBTITLE_CLASS_NAME,
    logoClassName: LOGO_CLASS_NAME,
    sectionClassName: undefined,
    subtitle: 'SelfieChallenge.success.notificationBody',
    title: 'SelfieChallenge.success.notificationTitle',
  },
};
